import { Button } from "@/components/ui/button";
import { KEYS } from "@/lib/tourHelper";
import { ChevronLeftRegular, ChevronRightRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface BottomBarProps {
  backLink: string;
  previousLink: string;
  nextLink: string;
  children?: React.ReactNode;
  onNavigate?: (link: string, source: "back" | "previous" | "next") => void;
}

function BottomBar({
  backLink,
  previousLink,
  nextLink,
  children,
  onNavigate,
}: BottomBarProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleNavigate = (link: string, source: "back" | "previous" | "next") => {
    if (!link) {
      return;
    }
    if (onNavigate) {
      onNavigate(link, source);
      return;
    }
    navigate(link);
  };
  return (
    <div className="flex sticky bottom-0 h-16 items-center justify-between border shadow px-6 bg-white">
      <Button
        data-tour={KEYS.BACK_BUTTON}
        variant="outline"
        onClick={() => handleNavigate(backLink, "back")}
      >
        <ChevronLeftRegular className="mr-2" />
        <span>{t("back")}</span>
      </Button>
      <div data-tour={KEYS.NAVIGATION_BUTTON} className="flex gap-3">
        <Button
          disabled={!previousLink}
          variant="secondary"
          onClick={() => handleNavigate(previousLink, "previous")}
        >
          <ChevronLeftRegular className="mr-2" />
          <span>{t("previous")}</span>
        </Button>
        <Button
          disabled={!nextLink}
          variant="secondary"
          onClick={() => handleNavigate(nextLink, "next")}
        >
          <span>{t("next")}</span>
          <ChevronRightRegular className="ml-2" />
        </Button>
      </div>
      <div>{children}</div>
    </div>
  );
}

export default BottomBar;
